export interface State {
  documentsViewed: string[];
}

export const initialState: State = {
  documentsViewed: []
};

const VIEWED_DOCUMENT = 'documents/VIEWED_DOCUMENT';

export const viewedDocument = (documentUID: string) => ({type: VIEWED_DOCUMENT, documentUID});

const documents = (state: State = initialState, action: any) => {
  switch (action.type) {
    case VIEWED_DOCUMENT:
      if (state.documentsViewed.includes(action.documentUID)) {
        return state;
      }
      const newDocumentsViewedList = [...state.documentsViewed, action.documentUID];
      return {...state, documentsViewed: newDocumentsViewedList};

    default:
      return state;
  }
};

export default documents;
